import React from 'react'
import { hasAvailableAction } from '../../../../../ui/gov-actions'
import DefaultForm from '../../../../../ui/forms/default-form'
import { sendEnrolmentDetailsFields, SendEnrolmentDetailsDone } from './fields'

const formValue = 'send_crn_dob_details'
const formLabel = 'Send CRN and DOB Details'

const available = record => hasAvailableAction(record, formValue)

const formEndPoint = ({ record }) =>
  process.env.REACT_APP_API_HOST + `/api/ccs-enrolments/${record.gov_id}/update_crn_dob_details`

const actionForm = ({ record }) => ({ handleSuccess }) => (
  <DefaultForm
    url={formEndPoint({ record })}
    value={formValue}
    label={formLabel}
    loadingTitle="Sending CRN and DOB details..."
    formComponent={sendEnrolmentDetailsFields({ record })}
    handleSuccess={() =>
      handleSuccess(
        {
          [formValue]: <SendEnrolmentDetailsDone record={record} />,
        },
        formValue
      )
    }
  />
)

export const sendEnrolmentDetails = ({ record, refresh_enrolments }) =>
  available(record)
    ? {
      label: formLabel,
      value: formValue,
      onComplete: refresh_enrolments,
      actionForm: actionForm({
        record,
      }),
    }
    : null



// WEBPACK FOOTER //
// ./src/care-enrolments/details/ccs-gov-enrolments/actions/send-enrolment-details/index.js